import history from "infra/helpers/history";
import { Menu } from "./typings/menu";
import { BsGraphUp, BsBoxSeam, BsDroplet } from "react-icons/bs";
import { FaHandshake, FaUsers, FaToolbox } from "react-icons/fa";
import {
  BiBarChartSquare,
  BiLineChart,
  BiLineChartDown,
  BiExport,
} from "react-icons/bi";
import { IoPeopleCircleOutline } from "react-icons/io5";
import { IoIosPeople } from "react-icons/io";
import { VscGraph } from "react-icons/vsc";
import {
  MdOutlineCalculate,
  MdAccountCircle,
  MdManageAccounts,
  MdOutlineMapsHomeWork,
  MdLink,
  MdCheck,
  MdMail,
  MdOutlineSell,
  MdGroup,
  MdPlaylistAddCheck,
  MdPersonOutline,
  MdOutlineCheck,
} from "react-icons/md";
import { FaRegHandshake } from "react-icons/fa";
import { VscChecklist } from "react-icons/vsc";
import { RiHandCoinLine, RiReservedFill } from "react-icons/ri";
import colors from "core/resources/theme/colors";
import { FiUserPlus } from "react-icons/fi";
import { HiOutlineDocumentMagnifyingGlass } from "react-icons/hi2";
import {
  AiOutlineCalendar,
  AiOutlineCodeSandbox,
  AiOutlineFundView,
  AiOutlineMessage,
  AiOutlineRedo,
  AiTwotoneFolder,
  AiOutlineBank,
  AiFillTool,
} from "react-icons/ai";
import { HiOutlineTrendingUp, HiOutlineTrendingDown } from "react-icons/hi";
import { ImFileText2 } from "react-icons/im";
import { PermissaoEnum } from "resources/enums/permissao";
import { checkPermission, checkOrPermission } from "infra/helpers/permission";
import { TenantMeResponse } from "core/features/auth/typings/user";
import { TipoTenantEnum } from "core/resources/enums/tenant";
import { TbZoomMoney } from "react-icons/tb";

const { Financeiro } = PermissaoEnum.Backoffice;

const navigateMenu = (url: string, newTab?: boolean) => {
  if (newTab) {
    window.open(url);
  } else {
    history.push(url);
  }
};

const menu = (tenant: TenantMeResponse): Menu[] => {
  const checkCadastros = checkOrPermission([
    PermissaoEnum.Backoffice.Administrativo.Unidade.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.GrupoUnidade.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Documento.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Usuario.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.AreaComum.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Fornecedor.Visualizar,
  ]);

  const checkAdministrativos = checkOrPermission([
    PermissaoEnum.Backoffice.Administrativo.Votacao.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Portaria.Gerenciar,
    PermissaoEnum.Backoffice.Administrativo.SolicitacaoCadastro.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Mensagem.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Reserva.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Mural.Visualizar,
  ]);

  const checkFinanceiroLevel1 = checkOrPermission([
    Financeiro.Dashboard,
    Financeiro.MovimentacaoBancaria,
    Financeiro.RetornoBancario.Visualizar,
    Financeiro.Transferencia.Visualizar,
  ]);

  const checkFinanceiroReceita = checkOrPermission([
    Financeiro.Arrecadacao.Visualizar,
    Financeiro.ContasReceber.Visualizar,
    Financeiro.Cobrancas.Visualizar,
    Financeiro.Acordo.Visualizar,
  ]);

  const checkFinanceiroDespesa = checkPermission(
    Financeiro.ContasPagar.Visualizar
  );

  const isCondominio = tenant.tipoTenantId === TipoTenantEnum.Condominio;
  const isAdmin = tenant.tipoTenantId === TipoTenantEnum.Admin;

  return [
    {
      title: "Início",
      icon: <i className="mdi mdi-home" />,
      visible: () => true,
      action: (newTab?: boolean) => navigateMenu("/dashboard", newTab),
      children: [],
    },
    {
      title: "Financeiro",
      icon: <i className="mdi mdi-chart-bar" />,
      divider: true,
      visible: () =>
        checkFinanceiroLevel1 ||
        checkFinanceiroReceita ||
        checkFinanceiroDespesa,
      children: [
        {
          // title: "",
          // visible: () => checkFinanceiroLevel1,
          // children: [

          title: "Geral",
          visible: () => checkFinanceiroReceita,
          icon: <ImFileText2 />,
          color: colors.blue,
          bg: colors.blue100,
          children: [
            // {
            //   title: "Dashboard",
            //   visible: () => checkPermission(Financeiro.Dashboard),
            //   icon: <MdDashboard fontSize={18} />,
            //   children: [],
            //   bg: colors.orange100,
            //   color: colors.orange,
            //   // action: (newTab?: boolean) => navigateMenu("/financeiro/dashboard",newTab),
            // },
            {
              title: "Movimentações Bancárias",
              visible: () => checkPermission(Financeiro.MovimentacaoBancaria),
              icon: <VscChecklist fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/movimentacoes-bancarias", newTab),
            },
            {
              title: "Calendário de Depósitos",
              visible: () => checkPermission(Financeiro.MovimentacaoBancaria),
              icon: <AiOutlineCalendar fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/calendario-depositos", newTab),
            },
            {
              title: "Retorno Bancário",
              visible: () =>
                checkPermission(Financeiro.RetornoBancario.Visualizar),
              icon: <MdOutlineCalculate fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/retorno-bancario", newTab),
            },
            {
              title: "Transferências",
              visible: () =>
                checkPermission(Financeiro.Transferencia.Visualizar),
              icon: <RiHandCoinLine fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/transferencias", newTab),
            },
            {
              title: "Conciliação Bancária",
              visible: () =>
                checkPermission(Financeiro.ConciliacaoBancaria.Visualizar),
              icon: <FaRegHandshake fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/conciliacao-bancaria", newTab),
            },
            {
              title: "Contas Bancárias",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.DadosCondominio.Gerenciar
                ),
              icon: <AiOutlineBank fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/meu-condominio?opcao=contas_bancarias", newTab),
            },
            {
              title: "Centros de custo",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.DadosCondominio.Gerenciar
                ),
              icon: <TbZoomMoney fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/meu-condominio?opcao=centros_de_custo", newTab),
            },
          ],
        },
        {
          title: "Receitas",
          visible: () => checkFinanceiroReceita,
          icon: <HiOutlineTrendingUp />,
          bg: colors.blue100,
          color: colors.blue,
          children: [
            {
              title: "Arrecadações",
              visible: () =>
                checkPermission(Financeiro.Arrecadacao.Visualizar) &&
                (isCondominio || isAdmin),
              icon: <BsGraphUp fontSize={18} />,
              children: [],
              bg: colors.blue100,
              color: colors.blue,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/receita/arrecadacoes", newTab),
            },
            {
              title: "A receber",
              visible: () =>
                checkPermission(Financeiro.ContasReceber.Visualizar),
              icon: <BiLineChart fontSize={18} />,
              children: [],
              bg: colors.blue100,
              color: colors.blue,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/receita/receber", newTab),
            },
            {
              title: "Recebidas",
              visible: () =>
                checkPermission(Financeiro.ContasReceber.Visualizar),
              icon: <MdCheck fontSize={18} />,
              children: [],
              bg: colors.blue100,
              color: colors.blue,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/receita/receber?status=pago", newTab),
            },
            {
              title: "Cobranças",
              visible: () => checkPermission(Financeiro.Cobrancas.Visualizar),
              icon: <BiBarChartSquare fontSize={18} />,
              children: [],
              bg: colors.blue100,
              color: colors.blue,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/receita/cobranca", newTab),
            },
            {
              title: "Acordos",
              visible: () => checkPermission(Financeiro.Acordo.Visualizar),
              icon: <FaHandshake fontSize={18} />,
              children: [],
              bg: colors.blue100,
              color: colors.blue,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/receita/acordo", newTab),
            },
            {
              title: "Recorrentes",
              visible: () =>
                checkPermission(Financeiro.ContasReceber.Visualizar),
              icon: <AiOutlineRedo fontSize={18} />,
              children: [],
              bg: colors.blue100,
              color: colors.blue,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/receita/conta-recorrente", newTab),
            },
          ],
        },
        {
          title: "Despesas",
          visible: () => checkFinanceiroDespesa,
          icon: <HiOutlineTrendingDown />,
          bg: colors.red100,
          color: colors.red,
          children: [
            {
              title: "A pagar",
              visible: () => checkPermission(Financeiro.ContasPagar.Visualizar),
              icon: <BiLineChartDown fontSize={18} />,
              children: [],
              bg: colors.red100,
              color: colors.red,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/despesa/pagar", newTab),
            },
            {
              title: "Pagas",
              visible: () => checkPermission(Financeiro.ContasPagar.Visualizar),
              icon: <MdCheck fontSize={18} />,
              children: [],
              bg: colors.red100,
              color: colors.red,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/despesa/pagar?status=pago", newTab),
            },
            {
              title: "Recorrentes",
              visible: () => checkPermission(Financeiro.ContasPagar.Visualizar),
              icon: <AiOutlineRedo fontSize={18} />,
              children: [],
              bg: colors.red100,
              color: colors.red,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/despesa/conta-recorrente", newTab),
            },
            {
              title: "Impostos",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Financeiro.Impostos.Visualizar
                ),
              icon: <AiOutlineBank fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/impostos", newTab),
            },
            {
              title: "Consumo de água, esgoto, energia e gás",
              visible: () => true,
              icon: <BsDroplet fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/consumo", newTab),
            },
            {
              title: "Exportação Contábil",
              visible: () => true,
              icon: <BiExport fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/exportacao-contabil", newTab),
            },
          ],
        },
        {
          title: "Planejamento",
          visible: () =>
            (checkPermission(Financeiro.Planejamento.ExecucaoOrcamentaria) ||
              checkPermission(Financeiro.Planejamento.PrevisaoOrcamentaria)) &&
            isCondominio,
          icon: <MdPlaylistAddCheck />,
          bg: colors.orange100,
          color: colors.orange,
          children: [
            {
              title: "Previsão orçamentária",
              visible: () =>
                checkPermission(Financeiro.Planejamento.PrevisaoOrcamentaria),

              children: [],
              bg: colors.green100,
              color: colors.green,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/previsao-orcamentaria", newTab),
            },
            {
              title: "Execução orçamentária",
              visible: () =>
                checkPermission(Financeiro.Planejamento.ExecucaoOrcamentaria),

              children: [],
              bg: colors.green100,
              color: colors.green,
              action: (newTab?: boolean) =>
                navigateMenu("/financeiro/execucao-orcamentaria", newTab),
            },
          ],
        },
      ],
    },
    {
      title: "Contábil",
      icon: <i className="mdi mdi-format-list-checkbox" />,
      visible: () => false,
      children: [
        {
          title: "Impostos e Encargos",
          visible: () => true,
          children: [
            {
              title: "Fechamento contábeis",
              icon: <i className="mdi mdi-cloud-print-outline" />,
              children: [],
              visible: () => true,
              bg: colors.purple100,
              color: colors.purple,
            },
            {
              title: "A Pagar",
              icon: <i className="mdi mdi-chart-bar" />,
              children: [],
              visible: () => true,
              bg: colors.blue100,
              color: colors.blue,
            },
            {
              title: "Consultar",
              icon: <i className="mdi mdi-note-search-outline" />,
              children: [],
              visible: () => true,
              bg: colors.purple100,
              color: colors.purple,
            },
            {
              title: "EFD-Reinf",
              icon: <i className="mdi mdi-chart-bar" />,
              children: [],
              visible: () => true,
              bg: colors.red100,
              color: colors.red,
            },
          ],
        },
      ],
    },
    {
      title: "Administração",
      icon: <i className="mdi mdi-format-list-checkbox" />,
      visible: () => checkCadastros || checkAdministrativos,
      children: [
        {
          title: "Cadastros",
          icon: <FiUserPlus />,
          bg: colors.blue100,
          color: colors.blue,
          visible: () => checkCadastros,
          children: [
            {
              title: "Condomínios",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Condominios.Visualizar
                ),
              icon: <MdPersonOutline fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) => navigateMenu("/condominio", newTab),
            },
            {
              title: "Unidades",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Unidade.Visualizar
                ),
              icon: <MdOutlineMapsHomeWork fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/cadastros/unidades", newTab),
            },
            {
              title: "Grupos de unidades",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.GrupoUnidade
                    .Visualizar
                ),
              icon: <MdLink fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/cadastros/grupos-unidades", newTab),
            },
            {
              title: "Documentos",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Documento.Visualizar
                ),
              icon: <AiTwotoneFolder fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/cadastros/documentos", newTab),
            },
            {
              title: "Perfis de usuários",
              visible: () => true,
              icon: <MdManageAccounts fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/cadastros/perfis", newTab),
            },
            {
              title: isCondominio ? "Responsáveis Legais" : "Usuários",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Usuario.Visualizar
                ),
              icon: <MdAccountCircle fontSize={18} />,
              children: [],
              bg: colors.blue100,
              color: colors.blue,
              action: (newTab?: boolean) => navigateMenu("/usuarios", newTab),
            },
            {
              title: "Áreas comuns",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.AreaComum.Visualizar
                ),
              icon: <AiOutlineCodeSandbox fontSize={18} />,
              children: [],
              bg: colors.green100,
              color: colors.green,
              action: (newTab?: boolean) =>
                navigateMenu("/cadastros/areas-comum", newTab),
            },
            {
              title: "Fornecedores",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Fornecedor.Visualizar
                ),
              icon: <IoPeopleCircleOutline fontSize={18} />,
              children: [],
              bg: colors.blue100,
              color: colors.blue,
              action: (newTab?: boolean) =>
                navigateMenu("/cadastros/fornecedores", newTab),
            },
            {
              title: "Clientes",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Cliente.Visualizar
                ),
              icon: <IoIosPeople fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/cadastros/clientes", newTab),
            },
            {
              title: "Controle de Patrimônios",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Equipamento.Visualizar
                ),
              icon: <FaToolbox fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/patrimonio", newTab),
            },
          ],
        },
        {
          title: "Administrativo",
          visible: () => checkAdministrativos,
          icon: <i className="mdi mdi-format-list-checkbox" />,
          bg: colors.purple100,
          color: colors.purple,
          children: [
            {
              title: "Anúncios",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Anuncio.Visualizar
                ),
              icon: <MdOutlineSell fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/anuncios", newTab),
            },
            {
              title: "Votação",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Votacao.Visualizar
                ),
              icon: <FaUsers fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/assembleias", newTab),
            },
            {
              title: "Portaria",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Portaria.Gerenciar
                ),
              icon: <AiOutlineFundView fontSize={18} />,
              children: [],
              bg: colors.green100,
              color: colors.green,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/portaria", newTab),
            },
            {
              title: "Solicitações",
              icon: <i className="mdi mdi-account-plus" />,
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.SolicitacaoCadastro
                    .Visualizar
                ),
              children: [],
              bg: colors.blue100,
              color: colors.blue,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/solicitacao-cadastro", newTab),
            },
            {
              title: "Mensagens",
              visible: () =>
                checkPermission([
                  PermissaoEnum.Backoffice.Administrativo.Mensagem.Visualizar,
                  PermissaoEnum.Backoffice.Administrativo.Portaria.Gerenciar,
                ]),
              icon: <AiOutlineMessage fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/mensagens", newTab),
            },
            {
              title: "Reservas",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Reserva.Visualizar
                ),
              icon: <AiOutlineCalendar fontSize={18} />,
              children: [],
              bg: colors.orange100,
              color: colors.orange,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/reservas", newTab),
            },
            {
              title: "Mural",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Mural.Visualizar
                ),
              icon: <AiOutlineCalendar fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/mural", newTab),
            },
            {
              title: "Encomendas",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Encomenda.Visualizar
                ),
              icon: <BsBoxSeam fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/encomenda", newTab),
            },
            {
              title: "Manutenções",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Manutencao.Visualizar
                ),
              icon: <AiFillTool fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/manutencao", newTab),
            },
            {
              title: "Orçamentos",
              visible: () =>
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Orcamento.Visualizar
                ),
              icon: <TbZoomMoney fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/administracao/orcamento", newTab),
            },
          ],
        },
      ],
    },
    {
      title: "Parceiros",
      visible: () =>
        checkPermission(PermissaoEnum.Backoffice.Admin.Parceiro.Visualizar),
      icon: <MdGroup fontSize={18} />,
      children: [],
      action: (newTab?: boolean) =>
        navigateMenu("/administracao/parceiros", newTab),
    },
    {
      title: "Relatórios",
      icon: <i className="mdi mdi-file" />,
      divider: true,
      visible: () =>
        checkPermission([
          PermissaoEnum.Backoffice.Relatorios.toString(),
          PermissaoEnum.Backoffice.Relatorios.Email.toString(),
          PermissaoEnum.Backoffice.Relatorios.Email.Visualizar,
          PermissaoEnum.Backoffice.Relatorios.Financeiro
            .DemonstrativoReceitaDespesa,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.TotalDespesas,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.Receitas,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.Inadimplentes,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.PrestacaoContas,
          PermissaoEnum.Backoffice.Relatorios.Financeiro.ComposicaoReceitas,
          PermissaoEnum.Backoffice.Relatorios.Financeiro
            .ComposicaoReceitasHorizontal,
          PermissaoEnum.Backoffice.Relatorios.Financeiro
            .DemonstrativoReceitaDespesaAnual,
          PermissaoEnum.Backoffice.Relatorios.Unidades.toString(),
          PermissaoEnum.Backoffice.Relatorios.Unidades.Visualizar,
          PermissaoEnum.Backoffice.Relatorios.Unidades.CertidaoNegativaDebitos,
        ]),
      children: [
        {
          title: "Relatórios",
          icon: <i className="mdi mdi-file" />,
          bg: colors.blue100,
          color: colors.blue,
          visible: () => true,
          children: [
            {
              title: "Envio de e-mail",
              visible: () =>
                checkPermission([
                  PermissaoEnum.Backoffice.Relatorios.Email.Visualizar,
                  PermissaoEnum.Backoffice.Relatorios.Email.toString(),
                ]),
              icon: <MdMail fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/relatorios/email", newTab),
            },
            {
              title: "Financeiro",
              visible: () =>
                checkPermission([
                  PermissaoEnum.Backoffice.Relatorios.Financeiro.toString(),
                  PermissaoEnum.Backoffice.Relatorios.Financeiro
                    .DemonstrativoReceitaDespesa,
                  PermissaoEnum.Backoffice.Relatorios.Financeiro.TotalDespesas,
                  PermissaoEnum.Backoffice.Relatorios.Financeiro.Receitas,
                  PermissaoEnum.Backoffice.Relatorios.Financeiro
                    .PrestacaoContas,
                  PermissaoEnum.Backoffice.Relatorios.Financeiro.Inadimplentes,
                  PermissaoEnum.Backoffice.Relatorios.Financeiro
                    .DemonstrativoReceitaDespesaAnual,
                  PermissaoEnum.Backoffice.Relatorios.Financeiro
                    .ComposicaoReceitas,
                  PermissaoEnum.Backoffice.Relatorios.Financeiro
                    .ComposicaoReceitasHorizontal,
                  PermissaoEnum.Backoffice.Relatorios.Financeiro
                    .DespesasPorCategoria,
                ]),
              icon: <VscGraph fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/relatorios/financeiro", newTab),
            },
            {
              title: "Reservas",
              visible: () =>
                checkPermission([
                  PermissaoEnum.Backoffice.Relatorios.Reservas.toString(),
                  PermissaoEnum.Backoffice.Relatorios.Reservas.Visualizar,
                ]),
              icon: <RiReservedFill fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/relatorios/reservas", newTab),
            },
            {
              title: "Unidades",
              visible: () =>
                checkPermission([
                  PermissaoEnum.Backoffice.Relatorios.Unidades.Visualizar,
                  PermissaoEnum.Backoffice.Relatorios.Unidades.toString(),
                ]),
              icon: <MdOutlineMapsHomeWork fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu("/relatorios/unidades", newTab),
            },
            {
              title: "Auditoria",
              visible: () =>
                [
                  TipoTenantEnum.Admin,
                  TipoTenantEnum.Administradora,
                  TipoTenantEnum.Incorporadora,
                  TipoTenantEnum.Imobiliaria,
                ].includes(tenant.tipoTenantId) || !tenant.tenantPai,
              icon: <HiOutlineDocumentMagnifyingGlass fontSize={18} />,
              children: [],
              action: (newTab?: boolean) =>
                navigateMenu("/relatorios/auditoria", newTab),
            },
            {
              title: "Certidão negativa de débitos",
              visible: () =>
                checkPermission([
                  PermissaoEnum.Backoffice.Relatorios.Unidades
                    .CertidaoNegativaDebitos,
                  PermissaoEnum.Backoffice.Relatorios.Unidades.toString(),
                ]),
              icon: <MdOutlineCheck fontSize={18} />,
              children: [],
              bg: colors.purple100,
              color: colors.purple,
              action: (newTab?: boolean) =>
                navigateMenu(
                  "/relatorios/unidades/certidao-negativa-debitos",
                  newTab
                ),
            },
          ],
        },
      ],
    },
  ];
};

export function useMenu() {
  return {
    menu,
  };
}
